import { Component, OnInit } from '@angular/core';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { CallBackEndService } from '../call-back-end.service';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

declare var getHexAscii: any;

@Component({
  selector: 'app-own-account-transfer',
  templateUrl: './own-account-transfer.component.html',
  styleUrls: ['./own-account-transfer.component.css']
})
export class OwnAccountTransferComponent implements OnInit {
  isShowScb:string;
  isLoad: boolean;
  isShow: string = 'page1';
  error: string = '';
  fromAccountNoComp: any = '';
  toAccountNoComp: any = '';
  amountComp: any;
  narrationComp: any;
  otpComp: any;
  scoAccounts: any = [];
  toscoAccounts: any = [];
  scoAndLoanAccounts: any = [];
  fromAccountNoCompValidate: string = 'hide';
  toAccountNoCompValidate: string = 'hide';
  disableNextBtn:boolean=false;
  disablesubBtn:boolean=false;

  regSpeci = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regchar = '/^[a-zA-Z]+$/';
  regexpspace = /\s+/;
  regZeroOnly = '^[0][0]*[0]$';
  regNum = /^[0-9]+$/ ;  // /^.*[0-9]/; 
  regexcap = /^.*?[A-Z]/;
  curRegExp = /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/;

  amountNotlankComp: string;
  disabled: boolean;
  amountmessageForSpaceComp: string;
  amountZeroOnlyComp: string;
  notValidAmmountComp: string;
  narrationValidateComp: string;
  OtpNotlankComp: string;
  disabledSubmit: boolean;
  greterThanZero: string;
  disablebuttonown : boolean;
  fromToacctNotSame : string ='';
  ammountAndRefno: any;
  amount : string='';
  refno : string ='';
  otpspace : string ='';
  fundTransferSuccessMessage : string ='';
  fundTransferErrorMessage : string ='';
  bankName: any;
  constructor(private webService: CallBackEndService,
   private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.bankName = webService.getBankName();

    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.scoAndLoanAccounts = JSON.parse(sessionStorage.getItem('scoAndLoanAccounts'));
  }

  ngOnInit() {
   
  }
  getOtp() {
   // this.spinnerService.show();
   console.log("In Otp after spins show"+this.disabled);
    this.error = '';
    this.allValidation();
   // this.disableNextBtn=true;
   this.disabled=false;
   console.log("In Otp after validation...  value of disbaled is: "+this.disabled);
     if(this.disabled)
     {
	  // this.spinnerService.hide();
	   console.log("In getOTP if disabled is true.....");
     }
   // else 
  // console.log('val of this.fromAccountNoComp ,this.toAccountNoComp: '+this.fromAccountNoComp+','+this.toAccountNoComp);
  // console.log('others: '+this.amountComp +' '+ this.narrationComp);
       if(this.fromAccountNoComp.match(this.toAccountNoComp))
    {
      this.fromToacctNotSame='no';
	 // this.spinnerService.hide();
	  console.log("In getOTP  if same account");
    }
    
   else if (this.fromAccountNoComp && this.toAccountNoComp && this.amountComp && this.narrationComp && this.disabled == false
   && this.getAmountValidComp() && this.messagesNarrationComp() ) {
    this.spinnerService.show();
    console.log('last else if called...........');
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName'));
	  request.param2 =sessionStorage.getItem('storedUserName');
	  // console.log("In getOTP Before WB call");
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
		  //  console.log("In getOTP Afer WB call");
        response = data;
        this.isLoad = false;
        this.spinnerService.hide();
        if (response !== null && response.status === 'S200')  {
          // console.log('Otp :' + response.param1);
          this.isShow = 'page2';
          this.disablesubBtn=false;

        } else if (response !== null) {
          this.error = response.param1;
          this.disableNextBtn=false;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
          this.disableNextBtn=false;
        }
      });
    }
  }

  cTcFundTransferRequest() {
    this.error = '';
     if (this.otpComp === undefined || this.otpComp === '') {
      this.OtpNotlankComp = 'no';
      this.disabledSubmit = true;
    }
    else{
       this.disablesubBtn=true;
     
    if (this.fromAccountNoComp && this.toAccountNoComp && this.amountComp && this.narrationComp && this.otpComp && this.disabled === false
     && this.getCompOTPValid() ) {
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.spinnerService.show();
      this.isLoad = true;
      const otpDetails: any = {
        'userName':sessionStorage.getItem('storedUserName'),
        'otp': getHexAscii('',this.otpComp)
      };
      request.param1 = getHexAscii('', this.fromAccountNoComp + this.toAccountNoComp + this.amountComp + this.narrationComp +sessionStorage.getItem('storedUserName') + this.otpComp);
      request.param2 = this.fromAccountNoComp;
      request.param3 = this.toAccountNoComp;
      request.param4 = this.amountComp;
      request.param5 = this.narrationComp;
      request.param6 = otpDetails;
      this.webService.getResponse(request, 'compToCompAndScbToScbFundTransfer').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        this.disablesubBtn=false;
        if (response !== null && response.status === 'S200')  {
          this.isLoad = false;
          this.amount=response.param5.creaditAmount;
          this.refno=response.param2;
        
          console.log("amount "+this.amount+"refno "+this.refno);
          this.fundTransferSuccessMessage= "Your transaction is completed successfully for Rs. "+ this.amount + " to account No : "+ response.param4 + " and Ref no "+this.refno;
          //alert('Fund Transfer Successfull! With Refrence No :' + response.param2);
            
          this.isShow = 'page3';
        } else if (response != null && (response.status==='S333' || response.status==='S334') ) {
          //this.error = response.param1;
          this.fundTransferErrorMessage= response.param1;
       
          //this.isShow = 'page3';
         // this.disablesubBtn=false;
        } else if (response != null ) {
          this.fundTransferErrorMessage='Your transaction is declined for Rs.'+this.amount+' due to '+ response.param1;

        }else {
          this.disablesubBtn=false;
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
    }
  }

  back() {
    this.error = '';
    this.isShow = 'page1';
    this.otpComp = '';
    this.disableNextBtn=false;
  }
 

  allValidation() {
	 console.log("In Otp allValidation"+this.disabled);
    this.validateField(this.fromAccountNoComp, 'fromAccountNoCompValidate');
    console.log("In Otp allValidation--0"+this.disabled);
	if (!this.disabled) {
		 console.log("In Otp allValidation--1"+this.disabled);
      this.validateField(this.toAccountNoComp, 'toAccountNoCompValidate');
      if (!this.disabled) {
		   console.log("In Otp allValidation--2"+this.disabled);
        this.getAmountValidComp();
      }if (!this.disabled) {
		   console.log("In Otp allValidation--3"+this.disabled);
          this.messagesNarrationComp();
        }
      }
  }

  validateField(modalValue, fieldName) {
    if (fieldName === 'fromAccountNoCompValidate' && (modalValue === undefined || modalValue === '')){
      this.fromAccountNoCompValidate = 'show';
    }
    else if (fieldName === 'fromAccountNoCompValidate' && (modalValue !== undefined && modalValue !== '')){
      this.fromAccountNoCompValidate = 'hide';
    }
    if (fieldName === 'toAccountNoCompValidate' && (modalValue === undefined || modalValue === ''))
      {
      this.toAccountNoCompValidate = 'show';
    }
    else if (fieldName === 'toAccountNoCompValidate' && (modalValue !== undefined && modalValue !== ''))
      {
      this.toAccountNoCompValidate = 'hide';
    }
    
  }

  removeMessage(fieldName) {
    this.fromToacctNotSame='';
    if (fieldName === 'fromAccountNoCompValidate')
      {
      this.fromAccountNoCompValidate = 'hide';
    }
    if (fieldName === 'toAccountNoCompValidate')
      {
      this.toAccountNoCompValidate = 'hide';
    }
  }

  getAmountValidComp() {
    if (this.amountComp === undefined || this.amountComp === '') {
      this.amountNotlankComp = 'no';
      this.disabled = true;
      return false;
    } else if (this.amountComp.match(this.regexpspace)) {
      this.amountmessageForSpaceComp = 'no';
      this.disabled = true;
      return false;
    } else if (this.amountComp.match(this.regZeroOnly)) {
      this.amountZeroOnlyComp = 'no';
      this.disabled = true;
      return false;
    } else if (!this.amountComp.match(this.curRegExp)) {
      this.notValidAmmountComp = 'no';
      this.disabled = true;
      return false;
    } else if ( parseFloat(this.amountComp) <= 0) {
      this.greterThanZero = 'no';
      this.disabled = true;
      return false;
    }else{
      return true;
    }
  }

  removeMessagesComp() {
    this.amountNotlankComp = '';
    this.amountmessageForSpaceComp = '';
    this.amountZeroOnlyComp = '';
    this.notValidAmmountComp = '';
    this.greterThanZero = '';
    this.disabled = false;
  }

  messagesNarrationComp() {
    if (this.narrationComp === undefined || this.narrationComp === '') {
      this.narrationValidateComp = 'no';
      this.disabled = true;
      return false;
    }else{
      return true;
    }
  }

  removeMessagesNarration() {
    this.narrationValidateComp = '';
    this.disabled = false;
  }

  getCompOTPValid() {
    var regSpeci = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
    var regchar = '/^[a-zA-Z]+$/';
    var regexpspace = /\s+/;
    var regZeroOnly = '^[0][0]*[0]$';
    if (this.otpComp === undefined || this.otpComp === '') {
      this.OtpNotlankComp = 'no';
      this.disabledSubmit = true;
      return false;
    }
    else if (this.otpComp.match(this.regexpspace)) {
      this.otpspace = 'no';
      this.disabledSubmit = true;
      return false;
    }else if (this.otpComp.match(regSpeci)) {
      this.otpspace = 'spcl';
      this.disabledSubmit = true;
      return false;
    }else if (!this.otpComp.match(this.regNum)) {
      this.otpspace = 'num';
      this.disabledSubmit = true;
      return false;
    }else{
      return true;

    }
  }
  getCompmesageOTPRemove() {
    this.OtpNotlankComp = '';
    this.otpspace='';
    this.error= '';
    this.disabledSubmit = false;
    this.fundTransferErrorMessage='';
  }
removeAcc()
{
  console.log("in onchange--");
  this.toscoAccounts=[];
 this.scoAccounts.forEach(account => {
   console.log("in sco--"+account);
   if(account!==this.fromAccountNoComp)
   {
     console.log("in tosco--"+account);
     this.toscoAccounts.push(account);
   }
 });
}
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/own-account-transfer/own-account-transfer.component.ts